// Self-hosted fonts (replaces the previous Google Fonts CDN <link>).
// Bundled by Vite so every visitor gets the .woff2 files from our own
// origin — no third-party data leak to Google on page load. Imports
// match the weights actually used in src/presentation/style.ts.
//
// `latin-{weight}.css` (vs `{weight}.css`) restricts each font to the
// Latin subset only — skips latin-ext / cyrillic / devanagari subsets
// that would otherwise add ~430KB of unused woff files to the build.
import '@fontsource/rajdhani/latin-500.css';
import '@fontsource/rajdhani/latin-600.css';
import '@fontsource/rajdhani/latin-700.css';
import '@fontsource/kode-mono/latin-400.css';
import '@fontsource/kode-mono/latin-500.css';
import '@fontsource/kode-mono/latin-600.css';
import '@fontsource/kode-mono/latin-700.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import '@fontsource/jetbrains-mono/latin-700.css';

import { getRoutePath } from './platform/index.js';
import { startGame } from './presentation/PhaserGame.js';
import { initAuth } from './store/auth.js';
import { initFriends } from './store/friends.js';
import { initOpenGames } from './store/openGames.js';
import { initProfile } from './store/profile.js';

// URL routing: /game/:id boots into the multiplayer JoinScene.
// Anything else (the typical / root) boots normally into HomeScene.
// Tiny pathname-based dispatch — no router lib needed at this scale.
const path = getRoutePath();
const gameMatch = path.match(/^\/game\/([a-z0-9]+)\/?$/i);
const isResetPasswordPath = /^\/reset-password\/?$/i.test(path);

// Kick off auth-session loading in parallel with Phaser boot. The
// SDK reads from localStorage so it resolves essentially instantly,
// but we don't block scene creation on it — HomeScene calls
// getAuth() lazily and listens to onAuthChange() for updates, so a
// quick "logged out → logged in" flicker on cold boot is harmless.
void initAuth();
// initProfile registers an auth listener that auto-fetches the
// user's row from public.profiles whenever a session lands. Safe
// to call before initAuth resolves — the listener will fire once
// the session arrives. Synchronous because it only wires listeners.
initProfile();
// initFriends does the same for the friends store — auto-fetches
// the user's friends + pending requests once a session arrives.
initFriends();
// initOpenGames just wires a sign-out listener that clears the
// cache. The actual fetch is triggered lazily by the Inbox LOBBY
// tab on mount — public-lobbies data is bigger than friends data
// and most users never visit the browser, so don't preload it.
initOpenGames();

if (gameMatch && gameMatch[1]) {
  startGame({ joinGameId: gameMatch[1] });
} else if (isResetPasswordPath) {
  startGame({ resetPassword: true });
} else {
  startGame();
}
